import styled from 'styled-components';

export const SidebarWrapper = styled.div`
  background-color: ${({ backgroundColor }) => `${backgroundColor} !important` ?? '#f8f9fa'};
  color: ${({ color }) => `${color} !important` ?? '#000'};
`;
